import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import { formatDateTimeEST } from 'shared/utility';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function DateTimeColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;
  let dateToDisplay = '';

  try {
    // after deleting legacy date from all envs leave only formatDateTimeEST(new Date(value))
    dateToDisplay = value?.includes('Z') ? formatDateTimeEST(new Date(value)) : value;
  } catch (error) {
    console.log('invalid date format: ', value);
  }

  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{dateToDisplay}</Typography>
    </Box>
  );
}
